import styled, { css } from 'styled-components'

import {
    FlexCentered,
    RowFlex,
    FlexJustifyContentSpaceBetween,
} from 'components/common/genericStyles'
import { getResponsiveFontSizeCSS } from 'helpers/css'
import { CLASS_NOTIFICATION_TYPES } from 'helpers/notification'

export const Container = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const Main = styled.div`
    min-height: 50px;
    width: min-content;
    box-shadow: 0px 3px 3px rgb(0 0 0 / 20%);
    border-radius: 50px;
    position: relative;
    margin-bottom: 10px;
    ${FlexCentered}
    ${FlexJustifyContentSpaceBetween}

    ${({ type }) => {
        switch (type) {
            case CLASS_NOTIFICATION_TYPES.vibing:
                return css`
                    background: radial-gradient(
                        97.91% 2583.4% at 97.91% 50%,
                        #36383c 0%,
                        #3b3440 50%,
                        #850078 100%
                    );
                `

            case CLASS_NOTIFICATION_TYPES.error:
                return css`
                    background-color: #d95146;
                `

            case CLASS_NOTIFICATION_TYPES.success:
                return css`
                    background-color: #089864;
                `

            default:
                return css`
                    background-color: #36383c;
                `
        }
    }}

`

export const Type = styled.div`
    height: 100%;
    ${FlexCentered}
    border-radius: 50px;
    margin: 0px 10px;
    position: relative;
    top: 2px;
`

export const MessageWrap = styled.div`
    margin-right: 10px;
    ${RowFlex}
    align-items: flex-start;
`

export const Message = styled.div`
    font-family: AvenirBold;
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(13, 15)};
    color: #ffffff;
    ${RowFlex}
    white-space: nowrap;
`

export const Name = styled(Message)`
    font-family: Avenir;
    color: #ce93d8;
`

export const VibeBy = styled(Name)`
    color: #869cec;
`

export const VibedTo = styled(Name)`
    color: #86ec90;
`

export const Prefix = styled.div`
    font-family: AvenirBold;
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(13, 15)};
    margin-right: 6px;
    color: #ef5c34;
`

export const VibingWrapper = styled.div`
    height: 100%;
    width: 65px;
`

export const NotificationIcon = styled.img`
    position: relative;
    height: 25px;
    width: 25px;
    top: -2px;
`
